import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';

import { catchError, filter, map, of, switchMap, withLatestFrom } from 'rxjs';

import * as DataAccessFairsActions from './data-access-fairs.actions';
import * as DataAccessFairsReducer from './data-access-fairs.reducer';
import * as DataAccessFairsSelectors from './data-access-fairs.selectors';

import { DataAccessFairsService } from '../../../services/fairs/data-access-fairs.service';

@Injectable()
export class DataAccessFairsEffects {
  loadFairConfig$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DataAccessFairsActions.appOpened),
      switchMap((_action) => {
        return this.fairService.getFairsConfig().pipe(
          map((config) => {
            return DataAccessFairsActions.appOpenedSucceeded({
              config: config,
            });
          }),
          catchError((err) => of(DataAccessFairsActions.appOpenedFailed({ error: err.status.toString() })))
        );
      })
    )
  );

  loadFair$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DataAccessFairsActions.fairOpened),
      withLatestFrom(this.store.pipe(select(DataAccessFairsSelectors.getFair))),
      filter(([_action, selectedFair]) => !selectedFair),
      switchMap(([action, _selectedFair]) =>
        this.fairService.getFair(action.fairId).pipe(
          map((fair) => {
            return DataAccessFairsActions.fairLoadSucceeded({
              fair: fair,
            });
          }),
          catchError((err) => of(DataAccessFairsActions.fairLoadFailed({ error: err.status.toString() })))
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private store: Store<DataAccessFairsReducer.FairsState>,
    private fairService: DataAccessFairsService
  ) {}
}
